export const apiConfig = {
  apiUrl: process.env.NODE_ENV === 'development' ? 'https://amagrar.codezilla.rocks/' : 'https://www.amagrar.com/expertensystem/'
}
